import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Help from './pages/Help';
import Legal from './pages/Legal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import ParrotOffer from './pages/ParrotOffer';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import { AuthProvider } from './lib/auth';
import { AdminGate } from './pages/admin/AdminGate';
import { WordbankAdmin } from './pages/admin/WordbankAdmin';
import { VoiceAdmin } from './pages/admin/VoiceAdmin';
import { SfxAdmin } from './pages/admin/SfxAdmin';
import { DesignSystemAdmin } from './pages/admin/DesignSystemAdmin';
import { EmailLogsAdmin } from './pages/admin/EmailLogsAdmin';
import { EmailSequencesAdmin } from './pages/admin/EmailSequencesAdmin';
import { NotificationLogsAdmin } from './pages/admin/NotificationLogsAdmin';
import { NotificationSequencesAdmin } from './pages/admin/NotificationSequencesAdmin';
import { PurchaseLogsAdmin } from './pages/admin/PurchaseLogsAdmin';
import { UsersAdmin } from './pages/admin/UsersAdmin';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/help" element={<Help />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/offer" element={<ParrotOffer />} />
          <Route path="/subscription/success" element={<SubscriptionSuccess />} />
          <Route path="/subscription" element={<SubscriptionSuccess />} />
          <Route
            path="/admin"
            element={<Navigate to="/admin/users" replace />}
          />
          <Route
            path="/admin/wordbank"
            element={
              <AdminGate>
                <WordbankAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminGate>
                <UsersAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/voice"
            element={
              <AdminGate>
                <VoiceAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/sfx"
            element={
              <AdminGate>
                <SfxAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/design-system"
            element={
              <AdminGate>
                <DesignSystemAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/email-sequences"
            element={
              <AdminGate>
                <EmailSequencesAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/emailSequences"
            element={<Navigate to="/admin/email-sequences" replace />}
          />
          <Route
            path="/admin/email-logs"
            element={
              <AdminGate>
                <EmailLogsAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/emailLogs"
            element={<Navigate to="/admin/email-logs" replace />}
          />
          <Route
            path="/admin/notification-sequences"
            element={
              <AdminGate>
                <NotificationSequencesAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/notificationSequences"
            element={<Navigate to="/admin/notification-sequences" replace />}
          />
          <Route
            path="/admin/notification-logs"
            element={
              <AdminGate>
                <NotificationLogsAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/notificationLogs"
            element={<Navigate to="/admin/notification-logs" replace />}
          />
          <Route
            path="/admin/purchase-logs"
            element={
              <AdminGate>
                <PurchaseLogsAdmin />
              </AdminGate>
            }
          />
          <Route
            path="/admin/purchaseLogs"
            element={<Navigate to="/admin/purchase-logs" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
